import { render } from "./ffuploadimgs.vue?vue&type=template&id=41433956"
import script from "./ffuploadimgs.vue?vue&type=script&lang=js"
export * from "./ffuploadimgs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__